"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assignFromAccountRaw = exports.assignToAccountRaw = exports.fromTronResourcesRaw = exports.toTronResourcesRaw = void 0;
const bignumber_js_1 = require("bignumber.js");
const toTronResourcesRaw = ({ frozen, delegatedFrozen, votes, tronPower, energy, bandwidth, unwithdrawnReward, lastWithdrawnRewardDate, lastVotedDate, cacheTransactionInfoById: cacheTx, }) => {
    const frozenBandwidth = frozen.bandwidth;
    const frozenEnergy = frozen.energy;
    const delegatedFrozenBandwidth = delegatedFrozen.bandwidth;
    const delegatedFrozenEnergy = delegatedFrozen.energy;
    const cacheTransactionInfoById = {};
    for (const k in cacheTx) {
        const { fee, blockNumber, withdraw_amount, unfreeze_amount } = cacheTx[k];
        cacheTransactionInfoById[k] = [fee, blockNumber, withdraw_amount, unfreeze_amount];
    }
    return {
        frozen: {
            bandwidth: frozenBandwidth
                ? {
                    amount: frozenBandwidth.amount.toString(),
                    expiredAt: frozenBandwidth.expiredAt.toISOString(),
                }
                : undefined,
            energy: frozenEnergy
                ? {
                    amount: frozenEnergy.amount.toString(),
                    expiredAt: frozenEnergy.expiredAt.toISOString(),
                }
                : undefined,
        },
        delegatedFrozen: {
            bandwidth: delegatedFrozenBandwidth
                ? {
                    amount: delegatedFrozenBandwidth.amount.toString(),
                }
                : undefined,
            energy: delegatedFrozenEnergy
                ? {
                    amount: delegatedFrozenEnergy.amount.toString(),
                }
                : undefined,
        },
        votes,
        tronPower,
        energy: energy.toString(),
        bandwidth: {
            freeUsed: bandwidth.freeUsed.toString(),
            freeLimit: bandwidth.freeLimit.toString(),
            gainedUsed: bandwidth.gainedUsed.toString(),
            gainedLimit: bandwidth.gainedLimit.toString(),
        },
        unwithdrawnReward: unwithdrawnReward.toString(),
        lastWithdrawnRewardDate: lastWithdrawnRewardDate
            ? lastWithdrawnRewardDate.toISOString()
            : undefined,
        lastVotedDate: lastVotedDate ? lastVotedDate.toISOString() : undefined,
        cacheTransactionInfoById,
    };
};
exports.toTronResourcesRaw = toTronResourcesRaw;
const fromTronResourcesRaw = ({ frozen, delegatedFrozen, votes, tronPower, energy, bandwidth, unwithdrawnReward, lastWithdrawnRewardDate, lastVotedDate, cacheTransactionInfoById: cacheTransactionInfoByIdRaw, }) => {
    const frozenBandwidth = frozen.bandwidth;
    const frozenEnergy = frozen.energy;
    const delegatedFrozenBandwidth = delegatedFrozen.bandwidth;
    const delegatedFrozenEnergy = delegatedFrozen.energy;
    const cacheTransactionInfoById = {};
    if (cacheTransactionInfoByIdRaw) {
        for (const k in cacheTransactionInfoByIdRaw) {
            const [fee, blockNumber, withdraw_amount, unfreeze_amount] = cacheTransactionInfoByIdRaw[k];
            cacheTransactionInfoById[k] = {
                fee,
                blockNumber,
                withdraw_amount,
                unfreeze_amount,
            };
        }
    }
    return {
        frozen: {
            bandwidth: frozenBandwidth
                ? {
                    amount: new bignumber_js_1.BigNumber(frozenBandwidth.amount),
                    expiredAt: new Date(frozenBandwidth.expiredAt),
                }
                : undefined,
            energy: frozenEnergy
                ? {
                    amount: new bignumber_js_1.BigNumber(frozenEnergy.amount),
                    expiredAt: new Date(frozenEnergy.expiredAt),
                }
                : undefined,
        },
        delegatedFrozen: {
            bandwidth: delegatedFrozenBandwidth
                ? {
                    amount: new bignumber_js_1.BigNumber(delegatedFrozenBandwidth.amount),
                }
                : undefined,
            energy: delegatedFrozenEnergy
                ? {
                    amount: new bignumber_js_1.BigNumber(delegatedFrozenEnergy.amount),
                }
                : undefined,
        },
        votes,
        tronPower,
        energy: new bignumber_js_1.BigNumber(energy),
        bandwidth: {
            freeUsed: new bignumber_js_1.BigNumber(bandwidth.freeUsed),
            freeLimit: new bignumber_js_1.BigNumber(bandwidth.freeLimit),
            gainedUsed: new bignumber_js_1.BigNumber(bandwidth.gainedUsed),
            gainedLimit: new bignumber_js_1.BigNumber(bandwidth.gainedLimit),
        },
        unwithdrawnReward: new bignumber_js_1.BigNumber(unwithdrawnReward),
        lastWithdrawnRewardDate: lastWithdrawnRewardDate
            ? new Date(lastWithdrawnRewardDate)
            : undefined,
        lastVotedDate: lastVotedDate ? new Date(lastVotedDate) : undefined,
        cacheTransactionInfoById,
    };
};
exports.fromTronResourcesRaw = fromTronResourcesRaw;
function assignToAccountRaw(account, accountRaw) {
    const tronAccount = account;
    if (tronAccount.tronResources) {
        accountRaw.tronResources = (0, exports.toTronResourcesRaw)(tronAccount.tronResources);
    }
}
exports.assignToAccountRaw = assignToAccountRaw;
function assignFromAccountRaw(accountRaw, account) {
    const tronResourcesRaw = accountRaw.tronResources;
    if (tronResourcesRaw)
        account.tronResources = (0, exports.fromTronResourcesRaw)(tronResourcesRaw);
}
exports.assignFromAccountRaw = assignFromAccountRaw;
//# sourceMappingURL=serialization.js.map